import { useState, useEffect } from "react"
import { Button, Input, Select, Card, Form, Upload, List, Typography, message, } from "antd"
import { useSelector } from 'react-redux';
import { UploadOutlined, FileTextOutlined, SearchOutlined, } from "@ant-design/icons"
import SoporteReemplazoService from "../../services/documentoReemplazo/SoporteReemplazoService"
const { Option } = Select
const { Text } = Typography

export function FormularioReemplazo({ onSuccess, onCancel, remplazo_ruta }) {
  const [loading, setLoading] = useState(false)
  const [proyectos, setProyectos] = useState([])
  const [archivos, setArchivos] = useState([])
  const [archivosFiltrados, setArchivosFiltrados] = useState([])
  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;
  const [formData, setFormData] = useState({
    proyecto: "",
    fecha: "",
    busquedaSoporte: "",
    codUnico: "",
    rutaArchivo: "",
    user: "usuario_actual",
    archivo: null,
  })

  useEffect(() => {
    cargarDatosIniciales()
  }, [])

  useEffect(() => {
    filtrarArchivos()
  }, [formData.busquedaSoporte, formData.proyecto, formData.fecha, archivos])

  const cargarDatosIniciales = async () => {
    try {
      const [proyectosData, archivosData] = await Promise.all([
        SoporteReemplazoService.proyectos(),
        SoporteReemplazoService.getArchivosReemplazables(remplazo_ruta)
      ])
      setProyectos(proyectosData)
      setArchivos(archivosData)
    } catch (error) {
      message.error("No se pudieron cargar los datos iniciales")
    }
  }

  const filtrarArchivos = () => {
    // Solo archivos (rutas que terminan en una extensión); se excluyen carpetas
    let filtrados = archivos.filter((archivo) => /\.[^/.\\]+$/.test(archivo.fullPath))
    // Función para normalizar texto (minúsculas, sin acentos ni signos)
    const normalize = (str) =>
      str
        .toLowerCase()
        .normalize("NFD") // descompone acentos
        .replace(/[\u0300-\u036f]/g, "") // quita acentos
        .replace(/[^\w\s]/gi, "") // quita signos de puntuación
        .trim()

    // Filtrar por proyecto usando nombre del proyecto
    if (formData.proyecto) {
      const proyectoSeleccionado = proyectos.find(
        (p) => p.oid.toString() === formData.proyecto
      )

      if (proyectoSeleccionado) {
        const nombreProyecto = normalize(proyectoSeleccionado.proyecto)
        filtrados = filtrados.filter((archivo) =>
          normalize(archivo.fullPath).includes(nombreProyecto)
        )
      }
    }
    // Filtrar por búsqueda de soporte (código único o nombre de archivo)
    if (formData.busquedaSoporte) {
      const busqueda = normalize(formData.busquedaSoporte)
      filtrados = filtrados.filter((archivo) => {
        const nombreArchivo = archivo.fullPath.split("/").pop()
        return (
          normalize(archivo.codUnico).includes(busqueda) ||
          normalize(nombreArchivo).includes(busqueda)
        )
      })
    }

    setArchivosFiltrados(filtrados)
  }

  const seleccionarArchivo = (archivo) => {
    setFormData({
      ...formData,
      codUnico: archivo.codUnico,
      rutaArchivo: archivo.fullPath,
      busquedaSoporte: archivo.codUnico,
    })
  }

  const handleFileChange = ({ fileList }) => {
    if (fileList.length > 0) {
      setFormData({ ...formData, archivo: fileList[0].originFileObj })
    } else {
      setFormData({ ...formData, archivo: null })
    }
  }

  const handleSubmit = async () => {
    if (!formData.codUnico) {
      message.error("Debe seleccionar un soporte a reemplazar")
      return
    }
    if (!formData.archivo) {
      message.error("Debe seleccionar un archivo de reemplazo")
      return
    }

    setLoading(true)
    try {
      const dataToSend = new FormData()
      dataToSend.append("codUnico", formData.codUnico)
      dataToSend.append("user", userLogin) // ✅ usa el login real del redux
      dataToSend.append("file", formData.archivo)
      await SoporteReemplazoService.upload(dataToSend)
      message.success("Soporte de reemplazo guardado correctamente")
      onSuccess()
    } catch (error) {
      console.error(error)
      message.error("No se pudo guardar el soporte de reemplazo")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Card variant="borderless">
      <Form layout="vertical" onFinish={handleSubmit}>
        {/* Selección de Proyecto */}
        <Form.Item label="Proyecto">
          <Select
            value={formData.proyecto}
            onChange={(value) => setFormData({ ...formData, proyecto: value })}
            placeholder="Seleccionar proyecto"
          >
            {proyectos.map((proyecto) => (

              <Option key={proyecto.oid} value={proyecto.oid.toString()}>
                {proyecto.proyecto}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Búsqueda de soporte */}
        <Form.Item label="Buscar soporte a reemplazar">
          <Input
            prefix={<SearchOutlined />}
            placeholder="Escribir código único o nombre del soporte..."
            value={formData.busquedaSoporte}
            onChange={(e) =>
              setFormData({ ...formData, busquedaSoporte: e.target.value })
            }
            disabled={!formData.proyecto} // 🔒 Deshabilitar hasta que se seleccione proyecto
          />
        </Form.Item>
        {formData.busquedaSoporte && (
          <List
            bordered
            hoverable
            style={{
              maxHeight: "200px",
              overflowY: "auto",
              marginBottom: "16px",
            }}
            dataSource={archivosFiltrados}
            locale={{
              emptyText: "No se encontraron archivos que coincidan con la búsqueda",
            }}
            renderItem={(archivo) => (
              <List.Item
                onClick={() => seleccionarArchivo(archivo)}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: formData.codUnico === archivo.codUnico ? "#e6f7ff" : "white", // azul clarito si está seleccionado
                  borderLeft: formData.codUnico === archivo.codUnico ? "4px solid #1890ff" : "4px solid transparent", // borde azul
                  transition: "all 0.2s ease",
                }}
              >
                <FileTextOutlined style={{ marginRight: 8, fontSize: 20, color: formData.codUnico === archivo.codUnico ? "#1890ff" : "inherit" }} />
                <div style={{ flex: 1 }}>
                  <Text strong style={{ display: "block", color: formData.codUnico === archivo.codUnico ? "#1890ff" : "inherit" }}>
                    {archivo.codUnico}
                  </Text>
                  <Text
                    type="secondary"
                    style={{ fontSize: "12px", wordBreak: "break-word" }}
                  >
                    {archivo.fullPath.replace(
                      /^DocumentosPOA.*?medio_verificacion_\d+\//,
                      ""
                    )}
                  </Text>
                </div>
              </List.Item>

            )}
          />

        )}
        {/* Subida de archivo */}
        <Form.Item label="Archivo de reemplazo">
          <Upload
            beforeUpload={() => false}
            onChange={handleFileChange}
            maxCount={1} // ✅ solo un archivo
          >
            <Button icon={<UploadOutlined />}>Seleccionar Archivo</Button>
          </Upload>
          {formData.archivo && (
            <Text type="secondary">
              Archivo seleccionado: {formData.archivo.name}
            </Text>
          )}
        </Form.Item>
        {/* Botones */}
        <Form.Item style={{ textAlign: "right" }}>
          <Button style={{ marginRight: 8 }} onClick={onCancel}>
            Cancelar
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={!formData.codUnico || !formData.archivo} // 🔒 Validación extra en el botón
          >
            Guardar Reemplazo
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}
